"use client";
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/cosmic/background-waves.tsx
import { motion } from "framer-motion";
import { colorMaps } from "./utils/background-colors.js";
import { jsx, jsxs } from "react/jsx-runtime";
function AnimatedWaves({ colorScheme, intensity }) {
  const colorMap = colorMaps[colorScheme];
  return /* @__PURE__ */ jsxs("div", { className: "absolute inset-0 overflow-hid\
den pointer-events-none", children: [
    /* @__PURE__ */ jsx("div", { className: "absolute bottom-0 w-full", children: /* @__PURE__ */ jsxs(
      "svg",
      {
        viewBox: "0 0 1440 320",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "none",
        className: "w-full h-auto",
        children: [
          /* @__PURE__ */ jsx("title", { children: "Decorative wave pattern" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M0,160 C320,240 640,280 960,260 C1280,240 1600,180 1920,160 L1\
920,320 L0,320 Z",
              fill: "rgba(224, 231, 255, 0.6)",
              className: "dark:fill-[rgba(30,58,138,0.4)]"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M0,220 C320,280 640,300 960,280 C1280,260 1600,220 1920,220 L1\
920,320 L0,320 Z",
              fill: "rgba(199, 210, 254, 0.5)",
              className: "dark:fill-[rgba(49,46,129,0.4)]"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M0,260 C320,290 640,310 960,300 C1280,290 1600,270 1920,260 L1\
920,320 L0,320 Z",
              fill: "rgba(165, 180, 252, 0.4)",
              className: "dark:fill-[rgba(76,29,149,0.3)]"
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(
      motion.div,
      {
        className: `absolute -bottom-32 -left-32 w-96 h-96 bg-gradient-to-r ${colorMap.
        waveFrom} ${colorMap.waveTo} rounded-full blur-3xl opacity-30`,
        animate: {
          x: [0, 100 * intensity, 0],
          y: [0, -50 * intensity, 0],
          scale: [1, 1.2 * intensity, 1]
        },
        transition: {
          duration: 25,
          repeat: Number.POSITIVE_INFINITY,
          ease: "easeInOut"
        }
      }
    ),
    /* @__PURE__ */ jsx(
      motion.div,
      {
        className: `absolute -top-32 -right-32 w-80 h-80 bg-gradient-to-l ${colorMap.
        waveFrom} ${colorMap.waveTo} rounded-full blur-3xl opacity-20`,
        animate: {
          x: [0, -80 * intensity, 0],
          y: [0, 60 * intensity, 0],
          scale: [1, 1.3 * intensity, 1]
        },
        transition: {
          duration: 30,
          repeat: Number.POSITIVE_INFINITY,
          ease: "easeInOut"
        }
      }
    )
  ] });
}
__name(AnimatedWaves, "AnimatedWaves");
export {
  AnimatedWaves
};
